// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-n_fJ","advertDetailHeaderPrice__value":"c-n_fK","advertDetailHeaderPrice__label":"c-n_fL"};